module.exports = __webpack_public_path__ + "static/scale-model-of-public-art-\"hammering-man\"-in-inglewood-california-aef22cdf68b74176fb9b5de9dd5f0a17.png";